var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0449 0H19.9538C8.93316 0 -0.000854492 8.93391 -0.000854492 19.9545V20.0455C-0.000854492 31.0661 8.93316 40 19.9538 40H20.0449C31.0656 40 39.9996 31.0661 39.9996 20.0455V19.9545C39.9996 8.93391 31.0656 0 20.0449 0Z",
    fill: "url(#paint0_linear_216_192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1887 8.1377H13.8115C10.392 8.1377 7.61023 10.9195 7.61023 14.3389V25.6621C7.61023 29.0815 10.392 31.8633 13.8115 31.8633H26.1887C29.6082 31.8633 32.39 29.0815 32.39 25.6621V14.3389C32.39 10.9195 29.6082 8.1377 26.1887 8.1377ZM9.79783 14.3389C9.79783 12.1261 11.5986 10.3253 13.8115 10.3253H26.1887C28.4015 10.3253 30.2024 12.1261 30.2024 14.3389V25.6621C30.2024 27.8749 28.4015 29.6757 26.1887 29.6757H13.8115C11.5986 29.6757 9.79783 27.8749 9.79783 25.6621V14.3389Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 25.7672C23.1797 25.7672 25.7681 23.1803 25.7681 19.9991C25.7681 16.8179 23.1811 14.231 19.9999 14.231C16.8187 14.231 14.2317 16.8179 14.2317 19.9991C14.2317 23.1803 16.8187 25.7672 19.9999 25.7672ZM19.9999 16.4199C21.9745 16.4199 23.5805 18.0259 23.5805 20.0005C23.5805 21.9751 21.9745 23.5811 19.9999 23.5811C18.0253 23.5811 16.4193 21.9751 16.4193 20.0005C16.4193 18.0259 18.0253 16.4199 19.9999 16.4199Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.302 15.163C27.1582 15.163 27.8561 14.4665 27.8561 13.6088C27.8561 12.7512 27.1596 12.0547 26.302 12.0547C25.4443 12.0547 24.7478 12.7512 24.7478 13.6088C24.7478 14.4665 25.4443 15.163 26.302 15.163Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_216_192",
    x1: 5.84302,
    y1: 34.1562,
    x2: 34.1554,
    y2: 5.84491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.5f17cd98804be81b7e811355ca4fa472.svg";
export { ForwardRef as ReactComponent };